<template>
  <div class="main-box main-min-height">
    <div class="table-box bgffffff">
      <div>
        <el-form :model="searchForm" size="mini" label-width="80px" ref="searchForm">
          <el-row :gutter="22">
            <el-col :span="10">
              <el-form-item prop="userName" label="用户名">
                <el-input style="width:100%" v-model="searchForm.userName" clearable placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label-width="20px">
                <el-button type="primary" @click="getInfo(true)">
                  查询
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column prop="id" label="id" align="center" width="80">
        </el-table-column>
        <el-table-column prop="headPortraitUrl" align="center" label="头像" width="100">
          <template slot-scope="{row}">
            <el-image style="width: 40px; height: 40px" :src="row.headPortraitUrl" :preview-src-list="[row.headPortraitUrl]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="nickName" label="昵称">
        </el-table-column>
        <el-table-column align="center" prop="phone" label="联系电话">
        </el-table-column>
        <el-table-column align="center" prop="fullName" label="所属店铺">
        </el-table-column>
         <el-table-column align="center" prop="orderNumber" label="下单数量">
        </el-table-column>
         <el-table-column align="center" prop="orderPrice" label="总金额">
        </el-table-column>
      </el-table>
      <Pagination location='left' :page='page' @getData="getInfo" />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/Pagination.vue'
export default {
  name: 'WxUser',
  components: { Pagination },
  data() {
    return {
      searchForm: {
        userName: null, //用户名
      },//查询条件
      page: { //翻页处理
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
      tableData: [],//表格参数
    };
  },
  computed: {},
  watch: {
    'searchForm.date': {
      handler(val) {
        this.searchForm.beginTime = val[0]
        this.searchForm.endTime = val[1]
      },
      deep: true
    }
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    //获取查询信息
    getInfo(bool) {
      bool ? this.page.currentPage = 1 : ''
      this.$WxUser.pageList(
        {
          ...this.searchForm,
          page: this.page.currentPage,
          limit: this.page.pageSize
        }
      ).then(({ data }) => {
        if (data.code === 200) {
          this.tableData = data.data
          this.page.total = data.count
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.y_color {
  color: #ff702e;
}
.lv_color {
  color: #0acd5e;
}
</style>
